var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "game-status-panel", class: { mobile: _vm.isMobile } },
    [
      !_vm.isMobile && _vm.showArenas ? _c("ArenaStatusIndicator") : _vm._e(),
      _c(
        "div",
        { staticClass: "status-text", class: { animating: _vm.animating } },
        [
          !_vm.fight.result
            ? _c("div", [_vm._v(" " + _vm._s(_vm.displayText) + " ")])
            : _c("div", { staticClass: "fight-result" }, [
                _vm._v(" F" + _vm._s(_vm.fight.fightNumber) + " "),
                _c("span", { staticClass: "player", class: _vm.fight.result }, [
                  _vm._v(_vm._s(_vm.$t(_vm.$capitalize(_vm.fight.result)))),
                ]),
                _vm._v(" "),
                _vm.fight.result !== "draw"
                  ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("Win")) + "! ")])
                  : _vm._e(),
              ]),
        ]
      ),
      _vm.config.enableJackpot
        ? _c("div", { staticClass: "jackpot-btn-wrapper" }, [
            _vm.config.displayLuckyDrawPrizes
              ? _c(
                  "div",
                  {
                    staticClass: "jackpot-physical-btn",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("jackpotPhysicalPopup")
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/jackpot-physical-btn.webp"),
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "jackpot-btn",
                class: { active: _vm.active },
                on: {
                  click: function ($event) {
                    return _vm.$emit("jackpotCollectPopup")
                  },
                },
              },
              [
                _c("img", {
                  class: { active: _vm.active },
                  attrs: {
                    src: `${
                      _vm.active
                        ? `${require("@/assets/images/fire-ic.gif")}`
                        : `${require("@/assets/images/crown.png")}`
                    }`,
                  },
                }),
                _c(
                  "div",
                  { staticClass: "text" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        class: { showAmount: _vm.showAmount },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Jackpot")) + " ")]
                    ),
                    _c(
                      "Transition",
                      { on: { "after-enter": _vm.onAfterEnter } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAmount,
                                expression: "showAmount",
                              },
                            ],
                            staticClass: "jackpot-pool-amount",
                            class: { showAmount: _vm.showAmount },
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.currencySymbol) + " "),
                            _c("animated-number", {
                              attrs: {
                                value: _vm.amountAfterKM,
                                formatValue: _vm.formatAmount,
                                duration: 500,
                              },
                            }),
                            _vm._v(_vm._s(_vm.amountKMSymbol) + " "),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }